// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__YZnsT","head":"Table_head__COOye","col":"Table_col__3eIZu"};